import { formatArr } from './index';

/**
 * 将对象数组存放到 localStorage 中
 * @param {string} key: String 数据键名
 * @param {Array[object]} data[]: [object] 数组数据
 * @returns null
*/
function stringifyObjArr(key, data) {
  if (!Array.isArray(data)) {
    return false;
  }
  const formatData = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < data.length; i++) {
    const element = data[i];
    formatData.push(JSON.stringify(element));
  }
  // localStorage.setItem(key, JSON.stringify(formatData));
  return formatData;
}

/**
 * 获取表头数据
 * @param {*} list 初始化数据
 * @param {*} data 匹配的数据
 */
export function getTabelColums({ list, data }) {
  let arr = [];
  const opArr = ['selection', 'expand'];
  const selectionArr = list.filter((it) => opArr.includes(it.type));
  const columnsList = list.filter((it) => !opArr.includes(it.type));
  columnsList.forEach((column) => {
    data.forEach((item) => {
      if (column.prop === item.prop || column.disabled) {
        arr.push(column);
      }
    });
  });
  const isOperateCur = arr.filter((it) => it.prop === 'operate');
  if (isOperateCur && isOperateCur.length) {
    arr = arr.filter((it) => it.prop !== 'operate');
  }
  return formatArr([...selectionArr, ...arr, ...isOperateCur], 'prop');
}

/**
 * 保存表头数据
 * @param {*} columnsKey 关键
 * @param {*} list 保存的数据
 */
export const setTabelColums = ({ columnsKey, list }) => {
  stringifyObjArr(columnsKey, list);
};
